import { Button } from "../ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { useTranslation } from "react-i18next";
import PDFViewer from "./PDFViewer";
import { ChevronLeft } from "lucide-react";
import { ReactNode } from "react";

type PrintPreviewProps = {
  fileURL: string | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  confirmButton?: ReactNode;
  title?: ReactNode;
};

const PrintPreview = ({
  title,
  fileURL,
  onOpenChange,
  open,
  confirmButton,
}: PrintPreviewProps) => {
  const { t } = useTranslation();

  const handleDownload = () => {
    if (fileURL === null) {
      return;
    }
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = "print.pdf";
    link.click();
  };

  return (
    <Dialog modal open={open} onOpenChange={onOpenChange}>
      <DialogContent
        needCloseButton={false}
        className="flex flex-col w-screen h-screen max-w-full m-0 rounded-none sm:rounded-none p-0 gap-0"
      >
        <DialogHeader className="flex flex-row items-center justify-between bg-white h-min border-b border-[#CBD5E1] py-4 px-5">
          <DialogClose
            className="left-4 top-4"
            onClick={() => onOpenChange(false)}
            asChild
          >
            <Button
              variant="link"
              className="flex flex-row items-center gap-2 text-[#006EAB] left-[20px] text-sm font-semibold font-['Raleway'] leading-normal"
            >
              <ChevronLeft className="h-3 w-3" color="#CBD5E1" />
              {t("backButton")}
            </Button>
          </DialogClose>

          <DialogTitle>{title ?? t("printPreview")}</DialogTitle>

          {confirmButton ?? (
            <Button onClick={handleDownload}>{t("printDownload")}</Button>
          )}
        </DialogHeader>

        <div className="flex flex-1 justify-center p-8 pt-12 overflow-auto">
          {fileURL !== null && <PDFViewer fileURL={fileURL} />}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PrintPreview;
